/**
 * CollabV3ThreadSection 컴포넌트
 * @description 상세 아래의 `Thread` 구역(앱 `CollabThreadSection`) — **맛보기만** 보인다. 고정 글을
 *   먼저 해서 3개까지, 그 아래 `See the rest in the app` 하나. 쪽 넘기기 · 글쓰기 상자 · 글 메뉴는 없다.
 *   글을 누르면 앱의 그 글이 열린다. 하트 · 댓글은 숫자만 보인다(웹 댓글 API 는 없다).
 *
 *   스레드를 못 받았으면(서버 장애 등) 구역째 접는다 — 페이지 전체가 죽을 일은 아니다.
 * @example <CollabV3ThreadSection thread={thread} subject={subject} />
 */
import { memo } from "react";

import { collabV3ThreadStyles as styles } from "./CollabV3Thread.styles";
import type { CollabV3ThreadProps } from "./CollabV3Thread.types";
import CollabV3ThreadItem from "./CollabV3ThreadItem";
import CollabV3SeeInApp from "./CollabV3SeeInApp";

import { COLLAB_V3_COPY } from "../../constants/collabV3Copy";
import { collabV3AppPaths } from "../../utils/collabV3AppPaths";

const copy = COLLAB_V3_COPY.thread;

const CollabV3ThreadSection = memo<CollabV3ThreadProps>(({ thread, subject }) => {
  if (!thread) return null;
  const path = collabV3AppPaths(subject.collabId).thread;
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>{copy.title}</h2>
      {thread.items.length === 0 ? (
        <p className={styles.empty}>{copy.empty}</p>
      ) : (
        <ul className={styles.list}>
          {thread.items.map((item) => (
            <CollabV3ThreadItem key={item.key} item={item} subject={subject} />
          ))}
        </ul>
      )}
      <CollabV3SeeInApp subject={subject} placement="thread" path={path} />
    </section>
  );
});

CollabV3ThreadSection.displayName = "CollabV3ThreadSection";

export default CollabV3ThreadSection;
